/** Subscriber sorted */
export interface SortedSubscriber extends Omit<ApiSchema<'SubscriberRead'>, 'id'> {
  id?: string | number,
  isTitle?: boolean,
  label?: string,
}

/**
 * @description Add name to subscriber. If the subscriber has no name, add the email as name.
 * - `subscriber` - subscriber
 */
const addNameToSubscriber = (subscriber: SortedSubscriber) => {
  if (!subscriber?.name) {
    if (subscriber?.email) return { ...subscriber, name: subscriber.email };
    return { ...subscriber, name: 'account.label.myaccount' };
  }
  return subscriber;
};

/**
 * @description Sort job subscribers based on type: main, full, selectable. Add titles for each type. Add recruiter title and checkbox.
 * - `jobSubscribers` - static list of subscribers from the API
 */
export const sortJobSubscribers = (jobSubscribers?: ApiSchema<'SubscriberRead'>[]): SortedSubscriber[] => {
  const mainSubscribers = jobSubscribers?.filter((subscriber) => subscriber.type === 'main').map(addNameToSubscriber);
  const fullSubscribers = jobSubscribers?.filter((subscriber) => subscriber.type === 'full').map(addNameToSubscriber);
  const selectableSubscribers = jobSubscribers?.filter((subscriber) => subscriber.type === 'selectable').map(addNameToSubscriber);

  const fullSubscribersTitle = fullSubscribers && fullSubscribers.length > 0
    ? [{
      isTitle: true,
      name: 'job.add.label.all_secondary',
    }] : [];

  const selectableSubscribersTitle = selectableSubscribers && selectableSubscribers.length > 0
    ? [{
      isTitle: true,
      name: 'job.add.label.give_also_access_to',
    }] : [];

  return [
    ...mainSubscribers ?? [],
    ...fullSubscribersTitle,
    ...fullSubscribers ?? [],
    ...selectableSubscribersTitle,
    ...selectableSubscribers ?? [],
  ];
};
